// 家戶「監控設定」頂端的範本列（SPEC #kinio-kms-templates「之後的變化」、#kinio-kms-templates-impl「客戶看範本」；k1-wbs M5-02）：
// 「沿用〈範本〉v3 · 2 項在這裡改過〔看差異〕」；有 kmgr.configure 的看到「〈範本〉有新版 v5」（不給內容）；封存的寫「〈範本〉已封存」。
// 沒套過範本、或 kmgr 還沒有這條路由（404）→ 不畫。
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { kmgrAbsent } from '../hooks';
import { NS } from '../parts';
import { tplApi } from './api';
import { overrideText, rowLabel } from './model';

export function HomeTemplateBanner({ api, homeId }: { api: string; homeId: string }) {
  const { t } = useTranslation(NS);
  const [open, setOpen] = useState(false);
  const q = useQuery({ queryKey: ['kmgr', 'home-template', homeId], queryFn: () => tplApi.homeTemplate(api, homeId), retry: (n, e) => !kmgrAbsent(e) && n < 1, staleTime: 30_000 });
  const tp = q.data?.template;
  if (!tp) return null;
  const names = q.data?.names;
  const orgName = names?.orgs?.[tp.template_org_id] ?? tp.template_org_id;
  const n = tp.local_overrides.length;
  return (
    <div className="km-bar" role="status" data-testid="km-home-template">
      <span className="ic" aria-hidden>
        ⧉
      </span>
      <span className="txt">
        {t('tpl.home_using', { name: tp.name, v: tp.version, org: orgName })}
        {n > 0 && ' · ' + t('tpl.home_overrides', { n })}
        {tp.archived && ' · ' + t('tpl.home_archived', { name: tp.name })}
        {tp.newer_version && ' · ' + t('tpl.home_newer', { name: tp.name, v: tp.newer_version })}
        {open && n > 0 && (
          <ul className="plain-list km-sub" data-testid="km-home-template-overrides">
            {tp.local_overrides.map((o) => (
              <li key={o.item + '/' + o.key}>
                {rowLabel(t, o.item, o.key, tp.body)} · {overrideText(t, o, names)}
              </li>
            ))}
          </ul>
        )}
      </span>
      {n > 0 && (
        <button className="btn btn-sm" onClick={() => setOpen((v) => !v)} aria-expanded={open}>
          {open ? t('tpl.hide_diff') : t('tpl.show_diff')}
        </button>
      )}
    </div>
  );
}
